import { Quill } from 'react-quill';

const Clipboard = Quill.import('modules/clipboard');

const resetAttributes = ['background', 'size', 'font', 'color'];

class PlainClipboard extends Clipboard {
    convert(html = null) {
        // Remove all attributes from each delta
        const delta = super.convert(html);
        if (!html) {
            delta.ops.forEach((op) => {
                // When pasting the html value is empty
                resetAttributes.forEach((attribute) => {
                    if (op.attributes) {
                        delete op.attributes[attribute];
                    }
                });
            });
        }
        return delta;
    }
}

Quill.register('modules/clipboard', PlainClipboard, true);
